import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import { apiClient } from '../services/api';

function Clusters() {
  const { activeCustomerId } = useContext(AuthContext);
  const [clusters, setClusters] = useState([]);
  const [error, setError] = useState('');

  const load = async () => {
    if (!activeCustomerId) return;
    try {
      const response = await apiClient.get('/clusters');
      setClusters((response.data?.clusters || []).filter((cluster) => cluster.record_type === 'cluster'));
      setError('');
    } catch (loadError) {
      setError(loadError.response?.data?.error || loadError.message || 'Unable to load RDF clusters.');
    }
  };

  useEffect(() => { load(); }, [activeCustomerId]);

  return (
    <div>
      <div className="page-header">
        <div><h1>RDF Clusters</h1><p className="subtitle">Fixed publisher and subscriber topologies for Virtuoso replication.</p></div>
        <Link className="btn btn-primary" to="/clusters/new">+ New RDF Cluster</Link>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {clusters.length === 0 ? (
        <div className="card"><h3>No RDF clusters</h3><p>Create a cluster after an eligible AWS Marketplace cluster agreement is active.</p></div>
      ) : (
        <div className="instances-grid">
          {clusters.map((cluster) => (
            <div className="instance-card" key={cluster.cluster_id}>
              <div className="instance-card-header"><h3>{cluster.project_name || cluster.cluster_id}</h3><span className={`status-badge ${cluster.status}`}>{cluster.status}</span></div>
              <p><strong>Plan:</strong> {cluster.tenant_module_cluster_plan || cluster.cluster_plan}</p>
              <p><strong>Topology:</strong> {cluster.topology?.total_nodes || '-'} nodes</p>
              <p><strong>Region:</strong> {cluster.region || '-'}</p>
              <Link className="btn btn-secondary" to={`/clusters/${cluster.cluster_id}`}>View Details</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Clusters;
